export enum UserRole {
    Admin = 1,
    Partner = 2,
    Customer = 3
}
